/*******************************************************************************
 * Copyright     : Copyright (c)  2024 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc. No part may be reproduced or transmitted in any form by any
 *                 means or for any purpose without the express written permission of Honeywell. *
 *******************************************************************************/
import React, { useState, useEffect, useCallback } from "react";

import { PageLoader } from "@forge/common";
import { useLDClient } from "launchdarkly-react-client-sdk";
import { useSelector } from "react-redux";

import RbmApplication from "./application/rbm";
import StandaloneApplication from "./application/standalone";
import { RootState } from "./store";
import "./App.scss";

const App = () => {
  const [appType, setAppType] = useState<string>("");
  const ldClient = useLDClient();
  const selectedOrg = useSelector((state: RootState) => state.global.selectedOrg);

  useEffect(() => {
    // Set the standalone state based on the URL query parameter
    if (window.location.search !== "?name=gatewaymanagement") {
      setAppType("standalone");
    } else {
      setAppType("iframe");
    }
  }, []);

  // Re-identify the LD context with projectId so enableEbiCognition flag can target by project
  useEffect(() => {
    if (ldClient && selectedOrg) {
      ldClient.identify({
        kind: "multi",
        user: { key: "anonymous" },
        project: { key: selectedOrg }
      });
    }
  }, [ldClient, selectedOrg]);

  const renderApp = useCallback(() => {
    if (appType === "standalone") {
      return <StandaloneApplication type={appType} />;
    } else if (appType === "iframe") {
      return <RbmApplication type={appType} />;
    } else {
      return (
        <div>
          <PageLoader isLoading={true} content="Loading" />
        </div>
      );
    }

  }, [appType]);

  return (
    <>
      {renderApp()}      
    </>
  );
};

export default App;
